import type { QueryClient } from '@tanstack/react-query';

export function invalidateCalendarQueries(
  queryClient: QueryClient,
  options?: { includeActivities?: boolean }
) {
  queryClient.invalidateQueries({
    queryKey: ['calendar'],
    exact: false,
  });
  queryClient.invalidateQueries({
    queryKey: ['calendar-week'],
    exact: false,
  });
  queryClient.invalidateQueries({
    queryKey: ['calendar-season'],
    exact: false,
  });
  queryClient.invalidateQueries({
    queryKey: ['calendarWeek'],
    exact: false,
  });
  queryClient.invalidateQueries({
    queryKey: ['calendarSeason'],
    exact: false,
  });
  queryClient.invalidateQueries({
    queryKey: ['calendarToday'],
    exact: false,
  });

  if (options?.includeActivities) {
    queryClient.invalidateQueries({
      queryKey: ['activities'],
      exact: false,
    });
  }
}
